import { render, staticRenderFns } from "./StudentClassCoordinatorAddEdit.vue?vue&type=template&id=aa543112"
import script from "./StudentClassCoordinatorAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassCoordinatorAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports